<template>
  <b-badge
    class="state-badge"
    pill
    :class="statusClass"
  >
    {{ status.name }}
  </b-badge>
</template>

<script>

import { ASSAY_STATES } from '@/api/resources/entityState/assay-state'

export default {
    name: 'LaboratoryStatusBadge',
    props: {
        status: { type: Object, required: true }
    },
    data() {
        return {
            invalidStatus: { bgColor: 'red', color: 'white', label: 'Inválido' }
        }
    },
    computed: {
        statusClass() {
            return this.statusOption.class
        },
        color() {
            return this.statusOption.color || 'white'
        },
        statusOption() {
            return Object.values(ASSAY_STATES).find((state) => state.code === this.status.code) || this.invalidStatus
        }
    }
}

</script>

<style scoped lang="scss">

  .sr-status-badge {
    width: 85px;
  }

</style>
